<template>
  <div :class="className">
    <BaseContainer>
      <div class="page-header__wrapper">
        <div class="page-header__inner">
          <div class="page-header__info">
            <h1 class="page-header__text">
              <slot></slot>
            </h1>
            <router-link
              :to="linkHref"
              class="page-header__link"
              v-if="linkHref"
            >
              <BaseIconText
                color="secondary"
                :iconAfter="linkBaseIcon"
                inlineFlex
                semiBold
                >{{ linkText }}</BaseIconText
              >
            </router-link>
          </div>
          <figure v-if="image">
            <img
              :src="getImage"
              class="page-header__image"
              alt="Alt description for the image"
            />
          </figure>
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import BaseIconText from '../elements/BaseIconText.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'PageHeader',
  components: { BaseContainer, BaseIconText },
  props: {
    linkHref: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: null
    },
    linkBaseIcon: {
      type: String,
      default: 'arrow_forward'
    },
    image: {
      type: String,
      default: ''
    },
    hero: {
      type: Boolean,
      default: false
    },
    media: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `page-header ${(this.media && 'page-header--media') || ' '} ${(this
        .full &&
        'page-header--full-width') ||
        ' '} ${(this.hero && 'page-header--with-image') || ' '}`
    },
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.page-header {
  @apply bg-theme-header;
}
.page-header__inner {
  @apply flex flex-col;
}
.page-header__link {
  @apply self-start no-underline p-4 -ml-4 mt-4 block font-semibold;
}
.page-header__link:hover {
  @apply bg-white;
}
.page-header__wrapper {
  @apply py-8;
}
.page-header__wrapper figure {
  @apply mt-4 mx-auto flex items-center justify-center min-w-1/2 max-w-4/5;
}
.page-header__info {
  @apply flex flex-col min-w-1/2;
}
.page-header__image {
  @apply max-h-xs mx-auto;
}
.page-header--media {
  @apply bg-body;
}

@screen md {
  .page-header__wrapper {
    @apply py-10;
  }
  .page-header__wrapper figure {
    @apply -mt-8 -mb-8 max-w-full;
  }
  .page-header__inner {
    @apply flex-row;
  }
  .page-header__link {
    @apply mt-6;
  }
}
@screen lg {
  .page-header__link {
    @apply mt-8;
  }
  .page-header__wrapper {
    @apply -mx-4 py-16;
  }
  .page-header__inner {
    @apply px-4 ml-4/12 mr-1/12;
  }

  .page-header--full-width .page-header__inner {
    @apply px-4 ml-1/12;
  }
  .page-header--with-image .page-header__wrapper {
    @apply pb-24;
  }
}
</style>
